import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { AnimatedElement } from "./AnimatedElement";
import { Tweens } from "../Components/Effects/Tweens";

@engineComponent(ComponentTypes.DisplayObject)
export class AnimatedPaylineNumber extends AnimatedElement {
    private _status: string = "animate";
    private _winYOffset: number = 6;

    constructor() {
        super();
    }

    public createByNode(node: Element) {
        super.createByNode(node);
    }

    public updateByNode(node: Element) {
        super.updateByNode(node);

        if (node.hasAttribute("Tints")) {
            let tints: Array<string> = node.getAttribute("Tints").split(";");
            if (tints != null) {
                for (let i: number = 0; i < tints.length; i++) {
                    if (this.childs["Object" + i] != null) {
                        this.childs["Object" + i].tint = parseInt(tints[i], 16);
                    }
                }
            }
        }

        if (node.hasAttribute("WinYOffset")) {
            this._winYOffset = parseInt(node.getAttribute("WinYOffset"));
        }

        if (node.hasAttribute("Method")) {
            switch (node.getAttribute("Method")) {
                case "nowin":
                    if (this._status !== "animate") {
                        this.animate();
                        this._status = "animate";
                    }
                    break;
                case "animate":
                    if (this._status !== "animate") {
                        this.animate();
                        this._status = "animate";
                    }
                    break;
                case "win":
                    if (this._status !== "win") {
                        this.animateWin();
                        this._status = "win";
                    }
                    break;
                case "cycle":
                    if (this._status !== "win") {
                        this.animateWin();
                        this._status = "win";
                    }
                    break;
            }
        }
    }

    public start(): void {
        super.start();
    }

    public stop(): void {
        super.stop();
    }

    public clone(): AnimatedPaylineNumber {
        const element: AnimatedPaylineNumber = new AnimatedPaylineNumber();
        element.style = this.style;
        element.x = this.x;
        element.y = this.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.visible = this.visible;
        element.childs = {};
        element.removeChildren();
        for (let key in this.childs) {
            element.childs[key] = this.childs[key].clone();
            element.addChild(element.childs[key]);
        }
        let container: PIXI.Container = new PIXI.Container();
        if (element.children != null) {
            while (element.children.length !== 0) {
                container.addChild(element.children[0]);
            }
        }
        element.addChild(container);
        element._lastY = this._lastY;
        element._winYOffset = this._winYOffset;
        element._positionOffset = this._positionOffset;
        element._rotationOffset = this._rotationOffset;
        element._scaleOffset = this._scaleOffset;
        element._rotationDuration = this._rotationDuration;
        element._scaleDuration = this._scaleDuration;
        element._timerRange = this._timerRange;
        element._positionRangeDuration = this._positionRangeDuration;
        element.start();
        element.markAsCloned();
        return element;
    }

    public animate(): void {
        super.animate();

        Tweens.removeTweens(this, "position");
        Tweens.positionTween(this, {
            tweenX: [this.x, this.x],
            tweenY: [this.y, this._lastY],
            tweenDuration: 30,
        });

        if (this.childs["Object3"] != null) {
            Tweens.removeTweens(this.childs["Object3"], "alpha");
            Tweens.alphaTween(this.childs["Object3"], {
                alphas: [this.childs["Object3"].alpha, 0],
                tweenDuration: 10,
            });
        }
    }

    public animateWin(): void {
        Tweens.removeTweens(this, "scale");
        Tweens.scaleTween(this, {
            tweenValues: [new PIXI.Point(this.scale.x, this.scale.y), new PIXI.Point(0.9, 1.1), new PIXI.Point(1, 1)],
            tweenDuration: 30,
            tweenEase: "Back.backOut",
            tweenLoop: true,
        });

        Tweens.removeTweens(this, "position");
        Tweens.positionTween(this, {
            tweenX: [this.x, this.x, this.x, this.x],
            tweenY: [this._lastY, this._lastY - this._winYOffset, this._lastY + this._winYOffset, this._lastY],
            tweenEase: "Back.backIn",
            tweenDuration: 60,
            tweenLoop: true,
        });

        if (this.childs["Object3"] != null && this.childs["Object3"].alpha < 1) {
            Tweens.removeTweens(this.childs["Object3"], "alpha");
            Tweens.alphaTween(this.childs["Object3"], {
                alphas: [this.childs["Object3"].alpha, 1, 0],
                tweenDuration: 60,
                tweenLoop: true,
            });
        }
    }

    public move(): void {
        super.move();
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/AnimatedPaylineNumber.ts
 **/